import { IDeleteFornecedorAvaliacaoUseCase } from "../../../presentation/useCases/delete/delete_fornecedor_avaliacao_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteFornecedorAvaliacaoUseCase
 */

export class DeleteFornecedorAvaliacaoUseCase implements IDeleteFornecedorAvaliacaoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteFornecedorAvaliacao(
    idFornecedor: number,
    idAvaliacaoFornecedor: number,
  ): Promise<void> {
    await this.repository.deleteFornecedorAvaliacao(
      idFornecedor,
      idAvaliacaoFornecedor,
    );
  }
}
